import React, { useState } from 'react';
import GridTemplateConfigurationController from '../grid-template-config.controller';
import { CQMasterDataStore } from '../../../../store/cq-master-data.store';
import { Utility } from '../../../../common/utility';
import { observer } from 'mobx-react';
import { TemplateSFObjectStore } from '../../../../store/models/template-object.model';
import { CQAppConstant } from '../../../../app-constants';
import { IFieldData } from '../../component-level-fields/component-field';

interface IProps { 
    selectedTemplateName: string;
    updateViewSourceComponentConfig: Function;
    fieldInfo: IFieldData
}

const GridPrefix = (props: IProps) => {
    const templateConfigCtrl: GridTemplateConfigurationController = new GridTemplateConfigurationController();
    const util: Utility = new Utility();
    const outputConfig = CQMasterDataStore.OutputConfig;
    const viewSourceComponentConfig = CQMasterDataStore.GridObject.gridComponentConfigView;
    const orgNameSpace = templateConfigCtrl.getCookieValue(CQAppConstant.LOGGED_IN_ORG_NAME_SPACE);                        
    const [prefix, setPrefix] = useState(outputConfig.getStoreKeyData(props.selectedTemplateName, 'prefix'));

    React.useEffect(() => {
            let childApiName = outputConfig.getStoreKeyData(props.selectedTemplateName, 'objectApiName');
            const childObject = TemplateSFObjectStore.sfObjects.filter((sfObject: any) => {
                return sfObject.name === childApiName;
            });
            let childObjectApiName:string = (childObject.length && childObject[0].name) as string;
            if (childObjectApiName && childObjectApiName.includes('__c')) {
                childObjectApiName = childObjectApiName.replace('__c', '');
            }
            childObjectApiName = util.toPascalCase(childObjectApiName);
            let recordTypeName = outputConfig.getStoreKeyData(props.selectedTemplateName, 'limitToRecordType');;
            if (recordTypeName.includes('_')) {
                recordTypeName = recordTypeName.replace('_', '');
            }
            if(childObject.length){
                let compName = '';
                const suffix = viewSourceComponentConfig.suffix || '';
                if (recordTypeName) {
                    compName = `cqui${prefix}${childObjectApiName}GridFor${recordTypeName}`;
                } else {
                    compName = `cqui${prefix}${childObjectApiName}${suffix}Grid`;
                }
                props.updateViewSourceComponentConfig('prefix', prefix , compName);
            }else{
                props.updateViewSourceComponentConfig('prefix', prefix);
            }
            templateConfigCtrl.updateFieldValue('prefix', prefix, props.selectedTemplateName);
    }, [prefix]);

    const defaultValueChange = async (e:any) => { 
        setPrefix(e.target.value)
        templateConfigCtrl.setPrefixName(props.selectedTemplateName,false,e.target.value);
    }
    return (
        <div className="slds-form-element">
            {!orgNameSpace && (
                <label className="slds-form-element__label">
                    {props.fieldInfo.required && 
                        <abbr className="slds-required" title="required">
                            * {' '}  
                        </abbr>
                    }
                    {props.fieldInfo.name}
                </label>
            )}
            <div className="slds-form-element__control">
                <input 
                    type="text" 
                    placeholder="Placeholder Text" 
                    required= {!orgNameSpace}
                    className="slds-input" onChange={defaultValueChange} 
                    value={viewSourceComponentConfig.prefix} 
                />
            </div>
        </div>
    )
}

export const GridComponentPrefix = observer(GridPrefix);